import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { actions } from './apiKeysReducer';
import ApiKeysComponent from './ApiKeysComponent';

const ApiKeysContainer = ({
  apiKeys,
  newApiKey,
  loading,
  fetchApiKeys,
  regenerateApiKey,
  createApiKey,
  clearNewApiKey,
}) => {
  useEffect(() => {
    fetchApiKeys();
  }, [fetchApiKeys]);

  return (
    <ApiKeysComponent
      apiKeys={apiKeys}
      newApiKey={newApiKey}
      loading={loading}
      onRegenerateKey={regenerateApiKey}
      onCreateKey={createApiKey}
      onClearNewKey={clearNewApiKey}
    />
  );
};

const mapStateToProps = (state) => ({
  apiKeys: state.guardian.apiKeys.list,
  newApiKey: state.guardian.apiKeys.newApiKey,
  loading: state.guardian.apiKeys.loading,
});

const mapDispatchToProps = {
  fetchApiKeys: actions.fetchApiKeys,
  regenerateApiKey: actions.regenerateApiKey,
  createApiKey: actions.createApiKey,
  clearNewApiKey: actions.clearNewApiKey,
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiKeysContainer);
